import React, { memo } from 'react';
import ChartComponent from '../../ChartComponent';
import AtlasChartCard from './AtlasChartCard';
import AtlasChartRuntime from './atlasChartRuntime';

/**
 * Chart renderer for Atlas viz payloads.
 *   - configs with meta.version >= 1 -> the styled card (sizes to its content)
 *   - everything else                -> the legacy ChartComponent in the same fixed-height box as before
 * variant: 'chat' (message stream) | 'brief' | 'shared' (brief panel, private / public share page).
 * Brief variants keep the brief's own wrapper classes so legacy brief charts render exactly as before.
 */
function AtlasChartView({ config, variant = 'chat' }) {
  const inBrief = variant === 'brief' || variant === 'shared';
  if (AtlasChartRuntime.hasMeta(config)) {
    return (
      <div className={inBrief ? 'atlas-brief-viz atlas-brief-viz-card' : 'atlas-viz atlas-viz-card'}>
        <AtlasChartCard config={config} variant={variant} />
      </div>
    );
  }
  return (
    <div className={inBrief ? 'atlas-brief-viz atlas-brief-viz-chart' : 'atlas-viz atlas-viz-chart'}>
      <ChartComponent chartData={config} />
    </div>
  );
}

export default memo(AtlasChartView);
